import React from "react";
import { useDevices } from "../devices";
import { Car, ChevronDown } from "lucide-react";

export default function DevicePicker({ onChange, className = "" }) {
  const { devices, selectedDeviceId, setSelectedDeviceId } = useDevices();
  if (devices.length <= 1) return null;
  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <Car size={14} className="text-slate-400 absolute left-2.5 pointer-events-none" />
      <select
        data-testid="device-picker"
        value={selectedDeviceId || ""}
        onChange={(e) => {
          setSelectedDeviceId(e.target.value);
          onChange?.(e.target.value);
        }}
        className="appearance-none bg-white border border-slate-200 rounded-full pl-8 pr-7 py-1 text-xs font-bold text-slate-700 outline-none focus:border-primary"
      >
        {devices.map((d) => (
          <option key={d.device_id} value={d.device_id}>
            {d.name}
          </option>
        ))}
      </select>
      <ChevronDown size={14} className="text-slate-400 absolute right-2 pointer-events-none" />
    </div>
  );
}
